import React, { PropTypes } from 'react'
import Link from 'react-router/lib/Link'

import Closed from './closed'

// filters enrolment based on advising state
const Content  = (page, is_open, is_registered, has_applied, is_me_open) => {
  if (!is_open) {
    return <Closed />
  }

  if (!is_me_open) {
    return (
      <div className="jumbotron">
        <h1>Your account is not open. Please pay the required fee to the cashier to activate your enrolment.</h1>
      </div>
    )
  }

  if (page === 'apply') {
    // must !has_applied
    if (has_applied) {
      return (
        <div className="jumbotron">
          <h1>You have already applied for enrolment.</h1>
          <hr />
          <div className="row">
            {!is_registered && <div className="col-sm-4 text-center">
              <Link to="/enrolment/modify" className="btn btn-info btn-lg btn-block">Modify my Enrolment</Link>
              <hr />
              If you have made your application but has subject modifications provided the registrar hasn't approved your application yet.
            </div>}
            {is_registered && <div className="col-sm-4 text-center">
              <Link to="/enrolment/add-withdraw-subjects" className="btn btn-warning btn-lg btn-block">Add/Withdraw Subjects</Link>
              <hr />
              If you are officialy registered and if enrolment is still open, you can add/withdraw subjects.
            </div>}
          </div>
        </div>
      )
    }
  } else if (page === 'modify') {
    // must have applied
    if (!has_applied) {
      return (
        <div className="jumbotron">
          <h1>You haven't applied for enrolment yet.</h1>
          <hr />
          <div className="row">
            <div className="col-sm-4 text-center">
              <Link to="/enrolment/apply" className="btn btn-success btn-lg btn-block">Apply for Enrolment</Link>
              <hr />
              If you haven't made any applications for enrolment yet for this semester.
            </div>
          </div>
        </div>
      )
    } else if (is_registered) {
      return (
        <div className="jumbotron">
          <h1>You are already registered.</h1>
          <hr />
          <div className="row">
            <div className="col-sm-4 text-center">
              <Link to="/enrolment/add-withdraw-subjects" className="btn btn-warning btn-lg btn-block">Add/Withdraw Subjects</Link>
              <hr />
              If you are officialy registered and if enrolment is still open, you can add/withdraw subjects.
            </div>
          </div>
        </div>
      )
    }
  } else if (page === 'add-withdraw') {
    // must be registered
    if (!is_registered && !has_applied) {
      return (
        <div className="jumbotron">
          <h1>You haven't applied for enrolment yet.</h1>
          <hr />
          <div className="row">
            <div className="col-sm-4 text-center">
              <Link to="/enrolment/apply" className="btn btn-success btn-lg btn-block">Apply for Enrolment</Link>
              <hr />
              If you haven't made any applications for enrolment yet for this semester.
            </div>
          </div>
        </div>
      )
    } else if (!is_registered && has_applied) {
      return (
        <div className="jumbotron">
          <h1>You are not yet officially enrolled.</h1>
          <hr />
          <div className="row">
            <div className="col-sm-4 text-center">
              <Link to="/enrolment/modify" className="btn btn-info btn-lg btn-block">Modify my Enrolment</Link>
              <hr />
              If you have made your application but has subject modifications provided the registrar hasn't approved your application yet.
            </div>
          </div>
        </div>
      )
    }
  }

  return null
}

Content.propTypes = {
  page: PropTypes.string,
  is_open: PropTypes.bool,
  is_registered: PropTypes.bool,
  has_applied: PropTypes.bool,
}

export default Content



// WEBPACK FOOTER //
// ./src/containers/Enrolment/content.js